import { useIntl } from 'react-intl';
import { Tabs } from 'antd';

import BRHeader from 'components/BRHeader/BRHeader';
import Container from 'components/Container/index';
import BusinessesListing from './components/BusinessesListing/BusinessesListing';
import BusinessesAnalytics from './components/BusinessesAnalytics/BusinessesAnalytics';

import './Businesses.less';

const Businesses = () => {
  const { TabPane } = Tabs;
  const intl = useIntl();

  const onTabChange = (key) => {};

  return (
    <Container
      className="br-businesses-container"
      header={
        <BRHeader title={intl.formatMessage({ id: 'businesses.title' })} />
      }
      content={
        <Tabs
          defaultActiveKey="1"
          onChange={onTabChange}
          destroyInactiveTabPane
        >
          <TabPane
            tab={intl.formatMessage({ id: 'businesses.tabs.listing' })}
            key="1"
          >
            <BusinessesListing />
          </TabPane>
          <TabPane
            tab={intl.formatMessage({ id: 'businesses.tabs.analytics' })}
            key="2"
          >
            <BusinessesAnalytics />
          </TabPane>
        </Tabs>
      }
    />
  );
};

export default Businesses;
